import * as React from 'react';
import useMediaQuery from '../hooks/useMediaQuery';
import BodyText from './BodyText';
import {ButtonCTAStyled} from './CTAStyled';
import Div from './Div.styled';
import SpaceLike from './Space';
import TypographyHeading from './Typography/TypographyHeading';
import TypographyBody from './Typography/TypographyBody';
import {getContentWithHtml, hasHtmlTags} from '../utils/contentUtils';

export interface IDescriptionPageProps {
  title: string;
  titleStrong: string;
  descriptions?: string;
  subTitle?: string;
  CTAButtonTitle?: string;
  handleCTA?: () => void;
  CTAButtonPrimaryTitle?: string;
  handleCTAPrimary?: () => void;
  icon?: React.ReactElement;
}

export default function DescriptionPage({
  title,
  titleStrong,
  descriptions,
  subTitle,
  icon,
  CTAButtonTitle,
  handleCTA,
  CTAButtonPrimaryTitle,
  handleCTAPrimary,
}: IDescriptionPageProps) {
  const {isMobile} = useMediaQuery();
  return (
    <Div
      maxWidth={isMobile ? '326px' : '666px'}
      margin="0 auto"
      customStyles={{textAlign: 'center'}}
    >
      {subTitle && (
        <TypographyBody size="body" bold color="black" textAlign="center">
          {subTitle}
        </TypographyBody>
      )}
      <TypographyHeading
        color="black"
        size="xLarge"
        tag="h2"
        textAlign="center"
        style={{paddingTop: subTitle && !isMobile ? 16 : 0}}
      >
        {title}
      </TypographyHeading>
      <TypographyHeading
        color="black"
        size="xLarge"
        tag="h2"
        bold
        textAlign="center"
        style={{
          paddingBottom: isMobile ? 24 : 40,
        }}
      >
        {titleStrong}
      </TypographyHeading>
      {descriptions && (
        <BodyText color="black">
          {hasHtmlTags(descriptions)
            ? getContentWithHtml(descriptions)
            : descriptions}
        </BodyText>
      )}
      {(CTAButtonPrimaryTitle || CTAButtonTitle) && (
        <SpaceLike
          direction="vertical"
          customStyles={{
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: isMobile ? '40px' : '80px',
          }}
          width={'100%'}
          size={isMobile ? 16 : 24}
        >
          {CTAButtonPrimaryTitle && (
            <ButtonCTAStyled
              tag="button"
              emphasis="primary"
              onClick={handleCTAPrimary}
              ariaLabel="aria label for CTA"
              size="large"
              {...(icon && {icon})}
            >
              {CTAButtonPrimaryTitle}
            </ButtonCTAStyled>
          )}
          {CTAButtonTitle && (
            <ButtonCTAStyled
              tag="button"
              emphasis="secondary"
              onClick={handleCTA}
              ariaLabel="aria label for CTA"
              size="large"
              {...(icon && {icon})}
            >
              {CTAButtonTitle}
            </ButtonCTAStyled>
          )}
        </SpaceLike>
      )}
    </Div>
  );
}
